import getCulturesLogic from "./getCulturesLogic";
import getCulturesFailureLogic from "./getCulturesFailureLogic";

export default [...getCulturesLogic, ...getCulturesFailureLogic];
